const REVIEWS_SECTION_ID = "reviews-section";

export default REVIEWS_SECTION_ID;
